import { useState } from "react";
import { Copy, Gift, Sparkles, Share2 } from "lucide-react";
import { toast } from "sonner";

export const FounderCard = ({ promo }) => {
  const [copied, setCopied] = useState(false);
  if (!promo?.eligible) return null;
  const link = `${window.location.origin}/register?ref=${promo.referral_code}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); } catch { /* fallback below */ }
    setCopied(true);
    toast.success("Invite link copied");
    setTimeout(() => setCopied(false), 2000);
  };
  const share = () => navigator.share
    ? navigator.share({ title: "VoyageQueue", text: `Join me on VoyageQueue and get ${promo.discount_pct}% off your membership`, url: link }).catch(() => {})
    : copy();

  return (
    <div data-testid="founder-card" className="mt-8 lux-card p-6 md:p-8 relative overflow-hidden">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p className="eyebrow flex items-center gap-2"><Sparkles className="w-3.5 h-3.5" />
            {promo.founder_number ? `Founding member #${promo.founder_number}` : promo.reason === "referral" ? "Invited member" : "Founding 500 offer"}
          </p>
          <p data-testid="founder-discount" className="font-serif-lux text-3xl mt-3">{promo.discount_pct}% off every membership</p>
          <p className="text-sm text-slate-400 mt-1">
            {promo.founder_number ? "Locked in for you. Share your link — friends who join with it get the same deal."
              : promo.reason === "referral" ? "Thanks to your invite, your discount applies automatically at checkout."
              : `Only ${promo.founder_limit - promo.founders_claimed} founding spots left — join any line to lock it in and get your own invite link.`}
          </p>
        </div>
        {promo.perks?.length > 0 && (
          <div data-testid="founder-perk" className="rounded-2xl border border-[#38BDF8]/50 bg-[#38BDF8]/10 px-4 py-3 max-w-xs">
            <p className="text-xs uppercase tracking-wider text-[#38BDF8] flex items-center gap-1"><Gift className="w-3.5 h-3.5" />Founder perks</p>
            <ul className="text-sm mt-2 space-y-1 list-disc pl-4">{promo.perks.map((p) => <li key={p}>{p}</li>)}</ul>
            <p data-testid="founder-streak" className="text-xs text-slate-400 mt-2">{promo.paid_streak % 12}/12 paid months toward your next free month</p>
          </div>
        )}
      </div>
      {promo.can_share && (
        <div className="mt-6 flex flex-col sm:flex-row gap-2">
          <input data-testid="founder-share-link" readOnly value={link} className="lux-input font-mono-lux text-xs" onFocus={(e) => e.target.select()} />
          <button data-testid="founder-copy-btn" onClick={copy} className="btn-ghost px-4 py-2.5 text-sm inline-flex items-center gap-2 justify-center whitespace-nowrap"><Copy className="w-4 h-4" />{copied ? "Copied!" : "Copy"}</button>
          <button data-testid="founder-share-btn" onClick={share} className="btn-gold px-4 py-2.5 text-sm inline-flex items-center gap-2 justify-center whitespace-nowrap"><Share2 className="w-4 h-4" />Share</button>
        </div>
      )}
      {promo.can_share && <p data-testid="founder-referral-count" className="text-xs text-slate-500 mt-3">{promo.referral_count} friend{promo.referral_count === 1 ? "" : "s"} joined with your link</p>}
    </div>
  );
};
